<script>
    import I18n from '@js/modules/translations';
    import Computation from '@js/modules/computation';

    import {mapStore} from '@js/stores/mapStore';
    import {userStore} from '@js/stores/userStore';

    import TimePicker from '@js/components/themes/TimePicker.svelte';

    import('@css/components/rides/_computation.scss');

    const {
        initialTime
    } = $props();

    let _previousUnit = userStore.unit;

    let currentTime = $state(initialTime || '00:00:00');

    const _handleTimeChange = (duration, chronoDuration) => {
        currentTime = chronoDuration;

        mapStore.currentDuration = duration;
        mapStore.durationComputed = false;

        mapStore.currentSpeed = Computation.computeSpeed(mapStore.currentDistance, chronoDuration);
        mapStore.speedComputed = true;
    };

    const _handleSpeedChange = (event) => {
        mapStore.currentSpeed = event.target.value;
        mapStore.speedComputed = false;

        mapStore.currentDuration = Computation.computeDuration(mapStore.currentDistance, mapStore.currentSpeed, {
            unit: userStore.unit,
            formatted: false
        });
        mapStore.durationComputed = true;
    };

    userStore.subscribe((userState) => {
        if (userState.unit !== _previousUnit) {
            _previousUnit = userState.unit;

            mapStore.currentSpeed = Computation.computeSpeed($mapStore.currentDistance, $mapStore.currentDuration);
        }
    });

    $effect(() => {
        if ($mapStore.durationComputed && !Computation.isDurationEqual($mapStore.currentDuration, currentTime)) {
            currentTime = Computation.formatDuration($mapStore.currentDuration, {chronoFormat: true});
        }
    });
</script>

{#if $mapStore.currentDistance}
    <div class="ride-computation my-12 p-4 rounded-2xl block-shadow">
        <h3 class="title-h3 text-center text-base">
            {I18n.t('js.ride.map.ride.tune')}
        </h3>

        <div class="row ride-computation-data">
            <div class="col s12 l5">
                <TimePicker class="computation-form-field"
                            label=""
                            currentTime={currentTime}
                            onTimeChange={_handleTimeChange}/>
            </div>

            <div class="col s12 l2 hidden md:block">
                <div class="divider-content text-gray-500 text-sm italic">
                    {I18n.t('js.helpers.or')}
                </div>
            </div>

            <div class="col s12 l5 hidden md:block">
                <div class="computation-form-field">
                    <label for="planner-speed-computation"
                           class="block w-full mb-1 text-sm md:text-xs font-bold text-gray-900 cursor-pointer">
                        {I18n.t('js.ride.map.ride.speed', {unit: I18n.t(`js.metrics.${window.unit}.speed_unit`)})}
                    </label>

                    <input type="text"
                           id="planner-speed-computation"
                           class="block w-full p-2.5 text-gray-900 text-sm rounded-lg focus:ring-blue-500 border border-gray-300 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                           placeholder={$mapStore.speedComputed ? Computation.formatSpeed($mapStore.currentSpeed, {unit: $userStore.unit}) : 0}
                           value={$mapStore.speedComputed ? '' : $mapStore.currentSpeed}
                           oninput={_handleSpeedChange}/>
                </div>
            </div>
        </div>
    </div>
{/if}
